'use strict';

class CreditNoteDraft {
  constructor($scope, $sce, $filter, $routeParams, $location, commonService, invoiceService, creditNoteService, recipientService, originatorService, userService) {
    this.$scope = $scope;
    this.$sce = $sce;
    this.$filter = $filter;
    this.$routeParams = $routeParams;
    this.$location = $location;
    this.commonService = commonService;
    this.invoiceService = invoiceService;
    this.userService = userService;
    this.creditNoteService = creditNoteService;
    this.recipientService = recipientService;
    this.originatorService = originatorService;
  }

  $onInit() {
    this.invoiceNumber = this.$location.search().regning;

    this.displayContractNumber = false;
    this.displayProjectReference = false;

    this.alert = {};
    this.creditNote = {
      invoiceDate: moment().format('YYYY-MM-DD'),
      orderDate: moment().format('YYYY-MM-DD'),
      accountNumber: null,
      deliveryDate: null,
      ourReference: null,
      yourReference: null,
      orderNumber: null,
      invoiceText: null,
      recipient: {},
      items: []
    };

    this.creditedInvoiceNoForTaxRates = null;
    this.summaryCalculated = false;

    this.taxEnabled = false;
    this.discount = 0;
    this.summary = {
      net: [],
      tax: [],
      total: 0,
      taxRates: []
    };

    this.taxRates = [];

    this.creditNoteNumber = this.$routeParams.number;

    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
        this.originatorForDisplay = angular.copy(this.originator);
        this.updateAccountOnOriginatorForDisplay();
        this.updateGiro();
      });

    this.originatorService.settings()
      .then((resp) => {
        this.taxEnabled = resp.data.defaults.totalIncludeMva;
        this.displayContractNumber = resp.data.defaults.displayContractNumber;
        this.displayProjectReference = resp.data.defaults.displayProjectReference;
      });

    this.$scope.$on('productList', (e, val) => {
      if (val) {
        this.creditNote.items = val;
      }
    });

    this.$scope.$on('productSummary', (e, val) => {
      if (val) {
        this.summaryCalculated = true;
        this.summary = val;
      }
    });

    this.$scope.$watchGroup([
      '$ctrl.creditNote.invoiceDate',
      '$ctrl.creditNote.recipient',
      '$ctrl.summary'
    ], (val, old) => {
      if (val !== old) {
        this.updateGiro();
      }
    });

    this.$scope.$on('selectedRecipient', (e, val) => {
      // update yourRef if empty
      if (this.creditNote.yourReference === '' || this.creditNote.yourReference === null) {
        this.creditNote.yourReference = val.yourReference;
      }

      // update discount if not set
      if (val.discount > 0 && this.creditNote.items.length) {
        this.discount = val.discount;

        this.alert = {
          type: 'info',
          message: this.$sce.trustAsHtml(`Rabatten på kreditnotalinjene er endret til <b>${val.discount}%</b>, standardrabatten for <b>${val.name}</b>.`)
        };

        this.creditNote.items.forEach((item) => {
          item.discount = val.discount;
          return item;
        });
      }

      this.creditNote.recipient = {
        number: val.number,
        customerNumber: val.customerNumber,
        name: val.name,
        email: val.email || null,
        address: {
          address1: val.address.address1 || null,
          address2: val.address.address2 || null,
          zip: val.address.zip || null,
          city: val.address.city || null,
          country: val.address.country || 'NORGE'
        },
        organisationNumber: val.organisationNumber || null,
        icd: val.icd || null
      };

      this.updateGiro();
    });

    this.commonService.datePicker({
      field: $('#orderDate')[0]
    });

    if (this.creditNoteNumber && this.creditNoteNumber !== 'ny') {
      this.load();
    } else if (this.invoiceNumber) {
      this.loadInvoice();
    }
  }

  allNetZero() {
    let sum = this.summary.net.reduce(function(a, b) { return a + b; }, 0);
    let x = (sum === 0);
    return x;
  }

  loadInvoice() {
    this.invoiceService.get(this.invoiceNumber)
      .then((resp) => {
        this.creditNote = resp.data;

        this.creditNote.invoiceDate = moment().format('YYYY-MM-DD');
        this.creditNote.invoiceText = `Kreditnota for fakturanummer ${this.invoiceNumber}`;

        this.canvasData.accountNumber = this.creditNote.accountNumber;

        angular.extend(this.creditNote, {
          creditedInvoiceNumber: resp.data.number
        });

        this.creditedInvoiceNoForTaxRates = resp.data.number;
        this.loadTaxRates(resp.data.number);
        this.updateAccountOnOriginatorForDisplay();
      });
  }

  load() {
    this.creditNoteService.getDraft(this.creditNoteNumber)
      .then((resp) => {
        this.creditNote = resp.data;
        this.creditedInvoiceNoForTaxRates = resp.data.creditedInvoiceNumber;
        this.loadTaxRates(resp.data.creditedInvoiceNumber);
      });
  }

  // get taxRates
  loadTaxRates(number) {
    this.invoiceService.getTaxRates(number)
      .then((resp) => {
        this.taxRates = resp.data;
        // let ar = Array.apply(null, new Array(this.taxRates.length)).map(Number.prototype.valueOf, 0);
        let l = this.taxRates.length;
        // let net = Array(l).fill(0);
        // let tax = Array(l - 1).fill(0);
        let net = Array.apply(null, new Array(l)).map(Number.prototype.valueOf, 0);
        let tax = Array.apply(null, new Array(l - 1)).map(Number.prototype.valueOf, 0);

        if (!this.summaryCalculated) {
          this.summary = {
            net: net,
            tax: tax,
            total: 0,
            taxRates: this.taxRates
          };
        }
      });
  }

  updateAccountOnOriginatorForDisplay() {
    if (this.creditNote && this.originatorForDisplay) {
      this.originatorForDisplay.bankAccount.number = this.creditNote.accountNumber;
    }
  }

  updateGiro() {
    this.canvasData = {
      invoiceNumber: '---',
      invoiceDate: moment(this.creditNote.invoiceDate, 'YYYY-MM-DD').format('DD.MM.YY'),
      total: this.summary.total,
      dueDate: '-- -- --'
    };

    // accountNumber: this.originator.bankAccount.number,
    if (this.originator && this.originator.contact && this.originator.bankAccount) {
      angular.extend(this.canvasData, {
        accountNumber: this.creditNote.accountNumber,
        originator: {
          name: this.originator.name,
          address1: this.originator.contact.address.address1,
          address2: this.originator.contact.address.address2,
          zipCity: `${this.originator.contact.address.zip} ${this.originator.contact.address.city}`,
          country: this.originator.contact.address.country,
          kid: this.originator.bankAccount.kid && this.originator.bankAccount.number === this.creditNote.accountNumber || false
        }
      });
    }

    if (this.creditNote.recipient && this.creditNote.recipient.address) {
      angular.extend(this.canvasData, {
        recipient: {
          name: this.creditNote.recipient.name,
          address1: this.creditNote.recipient.address.address1,
          address2: this.creditNote.recipient.address.address2,
          zipCity: `${this.creditNote.recipient.address.zip} ${this.creditNote.recipient.address.city}`,
          country: this.creditNote.recipient.address.country
        }
      });
    }
  }

  recipientError(err) {
    if (err.data && err.data.errors && err.data.errors.length) {
      err.data.errors.forEach((error) => {
        if (error.name.indexOf('recipient.') !== -1) {
          if ($('#recipientSearch').length) {
            $('#recipientSearch')
              .removeClass('ng-valid')
              .removeClass('ng-empty')
              .addClass('ng-invalid')
              .addClass('ng-dirty');
          } else {
            $('#recipientSearch')
              .removeClass('ng-invalid')
              .removeClass('ng-dirty')
              .addClass('ng-valid')
              .addClass('ng-empty');
          }
        }
      });
    }
  }

  process(draft = false) {
    // don't make any call if the total is 0
    if (this.summary.total === '0.00') {
      this.alert = {
        type: 'error',
        message: 'Totalsummen må være større enn 0,00'
      };

      return;
    }

    // cleanup items
    if (this.creditNote.items.length) {
      this.creditNote.items.forEach((item) => {
        item.unitPrice = this.$filter('defaultValue')(this.$filter('numberify')(item.unitPrice), null);
        item.quantity = this.$filter('defaultValue')(this.$filter('numberify')(item.quantity), null);
        return item;
      }, this);
    }

    if (draft && this.$filter('isEmptyObject')(this.creditNote.recipient)) {
      delete this.creditNote.recipient;
    }

    if (this.creditNoteNumber && this.creditNoteNumber !== 'ny') {
      this.creditNoteService.updateDraft(this.creditNoteNumber, this.creditNote)
        .then(() => {
          this.$location.search('regning', null);
          this.$location.search('kunde', null);

          if (draft) {
            this.$location.path(`/oversikt`);
          } else {
            this.$location.path(`/kreditnota/kladd/${this.creditNoteNumber}/send`);
          }
        })
        .catch((err) => this.recipientError(err));
    } else {
      this.creditNoteService.saveDraft(this.creditNote)
        .then((resp) => {
          this.$location.search('regning', null);
          this.$location.search('kunde', null);

          if (draft) {
            this.$location.path(`/oversikt`);
          } else {
            this.$location.path(`/kreditnota/kladd/${resp.data.number}/send`);
          }
        })
        .catch((err) => this.recipientError(err));
    }
  }

  save() {
    this.process(true);
  }

  send() {
    this.process();
  }

  delete() {
    if (this.creditNoteNumber) {
      this.creditNoteService.deleteDraft(this.creditNoteNumber)
        .then(() => this.$location.path('/oversikt'));
    }
  }

  cancel() {
    this.$location.path('/beslutning-kreves');
  }
}

CreditNoteDraft.$inject = ['$scope', '$sce', '$filter', '$routeParams', '$location', 'commonService', 'invoiceService', 'creditNoteService', 'recipientService', 'originatorService', 'userService'];

const creditNoteDraft = {
  controller: CreditNoteDraft,
  templateUrl: 'credit-note/draft.html'
};

angular
  .module('SendRegning')
  .component('creditNoteDraft', creditNoteDraft)
  .config(($routeProvider) => {
    $routeProvider
      .when('/kreditnota/kladd/:number', {
        title: 'Ny kreditnota',
        template: '<credit-note-draft />',
        noSidebar: true,
        overlay: true,
        secure: true
      });
  });
